import React, { useState, useEffect, useRef } from "react";
import { Col, Card, UncontrolledTooltip, Spinner } from "reactstrap";
import { withTranslation } from "react-i18next";
import axios from "axios";
import "./styles.scss";

import { unMountWidget } from "../../../../store/widgets/actions";

// Redux
import { useSelector, useDispatch } from "react-redux";

const CustomWidget = ({ t, isOpen, data, ...props }) => {
  const refIframe = useRef(null);
  const timeOut = useRef(null);
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [alreadySentPostM, setAlreadySentPostM] = useState(!data?.postMessage);
  const agentData = useSelector((state) => state.Login.data);
  const conversation = useSelector(
    (state) => state.ClientInformation?.info?.[props?.chatId]
  );
  const { mainTheme } = useSelector((state) => state.Layout);

  async function generatePayload(consumerInfo = {}) {
    const token = agentData?.AuthorizationRA?.replace("Bearer ", "") || "";

    const response = await axios.get(`/token-erp`)
    const tokenERP = response?.data?.data?.token
    if(!tokenERP) {
      throw new Error('Get Token ERP Error')
    }

    const payload = {
      token,
      consumer: {
        cpf: consumerInfo?.document || "",
      },
      agent: {
        profile: {
          profile_name: agentData?.profiles?.[0]?.name,
          profile_id: agentData?.profiles?.[0]?.id,
        },
        agentData: {
          user_id: agentData?.user?.id,
          user_name: agentData?.user?.name,
          extra_matricula: agentData?.user?.extra_matricula,
        },
      },
      authToken: tokenERP,
    };
    return payload;
  }

  async function sendPostMessage() {
    if (refIframe.current && data?.postMessage) {
      const { consumerInformation } = conversation;
      const payload = await generatePayload(consumerInformation);
      refIframe.current.contentWindow.postMessage(
        {
          payload,
          sender: "customer",
        },
        data?.url
      );
      setAlreadySentPostM(true);
    }
  }

  const getIframeSrc = () => {
    let url = data?.url;
    if (!url) return url;
    if (url.includes("webapp")) {
      const separator = url.includes("?") ? "&" : "?";
      url = `${url}${separator}_t=${Date.now()}`;
    }
    return url;
  };

  const handleRefresh = () => {
    if (refIframe.current) {
      refIframe.current.src = getIframeSrc();
      setIsLoading(true);
      setAlreadySentPostM(!data?.postMessage);
    }
  };

  function unMount() {
    dispatch(unMountWidget(props?.chatId, props?.widgetId));
  }

  useEffect(() => {
    if (
      data?.postMessage &&
      !isLoading &&
      !alreadySentPostM &&
      !!conversation?.consumerInformation
    ) {
      sendPostMessage();
    }
  }, [isLoading, conversation?.consumerInformation]);

  useEffect(() => {
    if (isOpen) {
      if (timeOut.current) {
        clearTimeout(timeOut.current);
      }
    } else {
      timeOut.current = setTimeout(() => {
        unMount();
      }, 30 * 1000 * 60);
      return () => {
        clearTimeout(timeOut.current);
      };
    }
  }, [isOpen]);

  useEffect(() => {
    return () => {
      unMount();
    };
  }, []);

  return (
    <Card
      className={`user-chat h-100 customWidget ${!isOpen && "invisibility"}`}
    >
      {!data?.full && (
        <div>
          <div className="p-3" style={{ height: "58px" }}>
            <Col className="header">
              <h5 className="font-size-15 mt-2 text-wrap pl-0 d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  style={{ marginRight: "10px" }}
                >
                  <path
                    fill={mainTheme === "light" ? "light" : "#fff"}
                    fillRule="evenodd"
                    d="M16.469,8.924l-2.414,2.413c-0.156,0.156-0.408,0.156-0.564,0c-0.156-0.155-0.156-0.408,0-0.563l2.414-2.414c1.175-1.175,1.175-3.087,0-4.262c-0.57-0.569-1.326-0.883-2.132-0.883s-1.562,0.313-2.132,0.883L9.227,6.511c-1.175,1.175-1.175,3.087,0,4.263c0.288,0.288,0.624,0.511,0.997,0.662c0.204,0.083,0.303,0.315,0.22,0.52c-0.171,0.422-0.643,0.17-0.52,0.22c-0.473-0.191-0.898-0.474-1.262-0.838c-1.487-1.485-1.487-3.904,0-5.391l2.414-2.413c0.72-0.72,1.678-1.117,2.696-1.117s1.976,0.396,2.696,1.117C17.955,5.02,17.955,7.438,16.469,8.924 M10.076,7.825c-0.205-0.083-0.437,0.016-0.52,0.22c-0.083,0.205,0.016,0.437,0.22,0.52c0.374,0.151,0.709,0.374,0.997,0.662c1.176,1.176,1.176,3.088,0,4.263l-2.414,2.413c-0.569,0.569-1.326,0.883-2.131,0.883s-1.562-0.313-2.132-0.883c-1.175-1.175-1.175-3.087,0-4.262L6.51,9.227c0.156-0.155,0.156-0.408,0-0.564c-0.156-0.156-0.408-0.156-0.564,0l-2.414,2.414c-1.487,1.485-1.487,3.904,0,5.391c0.72,0.72,1.678,1.116,2.696,1.116s1.976-0.396,2.696-1.116l2.414-2.413c1.487-1.486,1.487-3.905,0-5.392C10.974,8.298,10.55,8.017,10.076,7.825"
                  />
                </svg>
                {data?.title || t("Widget")}
              </h5>
              <div>
                <div
                  className="btn nav-btn nav-btn-light-sec"
                  onClick={handleRefresh}
                  id={`update-widget-${props?.chatId}`}
                >
                  <i
                    className={`bx bx-refresh ${
                      isLoading ? "loading-spinning" : ""
                      }`}
                  ></i>
                </div>
              </div>
              <UncontrolledTooltip
                placement="bottom"
                target={`update-widget-${props?.chatId}`}
                className="uncontrolledTooltip"
              >
                {<>{t("Update")}</>}
              </UncontrolledTooltip>
            </Col>
            <hr class="mb-0"></hr>
          </div>
        </div>
      )}
      <div className={`chat-conversation h-100 pb-4 mt-${data?.full ? 3 : 4}`}>
        {isLoading && (
          <div className="position-absolute loading">
            <div className="d-flex justify-content-center align-items-center h-100">
              <Spinner animation="border" size={"sm"} className="spinner" />
            </div>
          </div>
        )}
        <iframe
          ref={refIframe}
          style={data?.style || { width: 1200, height: "100%" }}
          src={getIframeSrc()}
          frameBorder="0"
          allow="clipboard-write"
          onLoad={() => {
            setIsLoading(false);
          }}
        />
      </div>
    </Card>
  );
};
export default withTranslation()(React.memo(CustomWidget));
